import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DocumentTemplateService } from '../document-template.service';
import { SignatureFlowData, SIGNATURE_TYPES } from './signature-flow-dialog.interface';
import { DocumentTemplateSignaturesComponent } from '../document-template-signatures/document-template-signatures.component';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-signature-flow-dialog',
    templateUrl: './signature-flow-dialog.component.html',
    styleUrls: ['./signature-flow-dialog.component.scss']
})
export class SignatureFlowDialogComponent implements OnInit {
    flowData: SignatureFlowData | null = null;
    isLoading = true;
    isExporting = false;
    errorMessage: string | null = null;

    signatureTypes = SIGNATURE_TYPES;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            id: number;
            name: string;
            document_generabil_dual: boolean;
        },
        private dialogRef: MatDialogRef<SignatureFlowDialogComponent>,
        private dialog: MatDialog,
        private templateService: DocumentTemplateService,
        private authService: AuthService
    ) {}

    ngOnInit(): void {
        this.loadFlowData();
    }

    loadFlowData(): void {
        this.isLoading = true;
        this.errorMessage = null;

        this.templateService.getSignatureFlowData(this.data.id).subscribe({
            next: (response: any) => {
                if (response && response.data) {
                    this.flowData = response.data;
                }
                this.isLoading = false;
            },
            error: (error) => {
                console.error('Error loading signature flow data:', error);
                this.errorMessage = 'Nu s-a putut încărca fluxul de semnături.';
                this.isLoading = false;
            }
        });
    }

    closeDialog(): void {
        this.dialogRef.close();
    }

    openSignaturesConfig(): void {
        this.dialogRef.close();

        this.dialog.open(DocumentTemplateSignaturesComponent, {
            maxWidth: '90%',
            width: '800px',
            height: '90vh',
            data: {
                id: this.data.id,
                name: this.data.name,
                document_generabil_dual: this.data.document_generabil_dual
            }
        });
    }

    getSignTypeIcon(signType: number): string {
        return this.signatureTypes[signType]?.icon || 'edit';
    }

    getSignTypeLabel(signType: number): string {
        return this.signatureTypes[signType]?.label || 'Semnare';
    }

    getSignTypeClass(signType: number): string {
        return this.signatureTypes[signType]?.class || 'sign-type-semnare';
    }

    get hasCompletSignatures(): boolean {
        return !!(this.flowData?.exemplar_complet && this.flowData.exemplar_complet.length > 0);
    }

    get hasCetateanSignatures(): boolean {
        return !!(this.flowData?.exemplar_cetatean && this.flowData.exemplar_cetatean.length > 0);
    }

    async exportToPdf(): Promise<void> {
        if (this.isExporting) return;

        this.isExporting = true;

        try {
            // Get the PDF URL from service
            const pdfUrl = this.templateService.getSignatureFlowPdfUrl(this.data.id);

            // Get the auth token
            const token = await this.authService.getToken();

            // Fetch PDF from server
            const response = await fetch(pdfUrl, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept': 'application/pdf'
                }
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blob = await response.blob();

            // Create download link
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `flux-semnaturi-${this.data.name.replace(/[^a-zA-Z0-9]/g, '-')}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error downloading PDF:', error);
        } finally {
            this.isExporting = false;
        }
    }
}
